module.exports = __webpack_public_path__ + "img/prescription-bottle.4634b8e9.svg";